const devUrl="https://t55.win159.com"
// const devUrl="https://www.66zxff.com"
// const devUrl="https://gsbet888.net"

module.exports= {
  baseUrl:devUrl
}



// WEBPACK FOOTER //
// ./src/api/base-url.js